import { wrapSyncFunc } from '../util';
export var maxCount = wrapSyncFunc(function (rule, value) {
  var maxCount = rule.maxCount;

  if (maxCount == null) {
    return;
  }

  if (Array.isArray(value) && value.length) {
    return value.length <= +maxCount;
  }
});